class BESSAppProjectDependencyAndSubDependency extends BESSAppProjectDependencyWithSubDependency {

    isEnabled() {
        let event1 = this.getLastEventFor(this.qId1Event);
        let event2 = this.getLastEventFor(this.qId2Event);

        if (event1 && event2) {
            return this.qId1EventValueIs(event1.getValue()) && this.qId2EventValueIs(event2.getValue());
        }
        return false;
    }
}